import { Timeline } from '../timeline/timeline';
import { Map as TLMDMap } from '../map/map';
import * as CryptoJS from 'crypto-js';
import { AnimationMode } from './types';
export const VISUALIZER_KEY_TIMELINE = 'timeline';
export const VISUALIZER_KEY_MAP = 'map';

/**
 * With these levels the visualizers can optimize themeselves. E.g.
 * the statistics visualiser only has to deal with (filter or lower) updates 
 */
export enum VisualizationUpdateLevel {
  settings = 0,
  data = 0,
  filter = 1,
  selection = 2,
  animation = 3,
  visualization = 4
}
export interface VisualizerConfiguration {
  type: string,
  icon: string,
  labels: { [key: string]: string },
  options: any
}
export interface Visualizer {
  setControls: (controls: { [key: string]: VisualizerControl }) => Visualizer,
  key: () => string,
  type: () => string,
  setTimeline: (timeline: Timeline) => void,
  setMap: (map: TLMDMap) => void,
  //TODO now (20210426) we have the level parameter we should
  //be able to put updateSelection logic into refresh
  refresh: ( level: VisualizationUpdateLevel ) => void,
  updateSelection: () => void
}

export interface VisualizerControl {
  enabled: (visualizerKey: string) => boolean,
  setEnabled: (visualizerKey: string, enabled: boolean, className?: string) => void
  animationMode: (visualizerKey: string) => AnimationMode
}

export interface VisualId {
  elemId: string,
  dataIds: string[]
}

export const createElemSelector = (identifiers: string[]): string => {
  return `_${CryptoJS.MD5(identifiers.sort().join('#')).toString(CryptoJS.enc.Hex)}`;
}
